module.exports = __webpack_public_path__ + "img/bed.b19d3ad6.svg";